import { render, staticRenderFns } from "./DashboardAssociado.vue?vue&type=template&id=72eb88ce"
import script from "./DashboardAssociado.vue?vue&type=script&lang=js"
export * from "./DashboardAssociado.vue?vue&type=script&lang=js"
import style0 from "./DashboardAssociado.vue?vue&type=style&index=0&id=72eb88ce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports